import React from 'react'
import { OutboundLink } from 'gatsby-plugin-gtag'
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText,
  EuiIcon
} from '@elastic/eui'


export default function softwareVideos() {

  return (
    <React.Fragment>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed 
                    id="FjE95bL7_p4"
                    title="INSTAR DDNS Dienst"
                    adNetwork={true}
                    poster="maxresdefault" //hqdefault
                    noCookie={true}
                />
              }
              footer={
                <EuiText>
                <p>In diesem Video erklären wir Ihnen &quot;hoffentlich&quot; auf verständliche Weise wie DDNS funktioniert, was es ist und wie das Prinzip der Portweiterleitung funktioniert. Zudem zeigen wir auch kurz auf wie P2P funktioniert und aufgebaut ist.</p>
                <p>Folgen Sie uns jetzt im INSTARTV YouTube Kanal, abbonieren Sie uns und erhalten Sie automatisch Informationen sobald neue Videos verfügbar sind damit Sie Ihre INSTAR IP Kamera noch besser nutzen können. Auf <OutboundLink href="https://www.youtube.com/watch?v=FjE95bL7_p4" target="_blank" rel="noopener noreferrer">Youtube ansehen <EuiIcon type="popout" /></OutboundLink></p>
                </EuiText>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
    </React.Fragment>
  );
}